import zhLocale from 'element-ui/lib/locale/lang/zh-CN' //引入element语言包
export default {
	all:{
		jiantizhongwen:'简体中文',
		fantizhongwen:'繁体中文',
		yingwen:'英文',
		yuyanxuanze:'语言选择',
		shezhi:'设置',
		xiugaimima:'修改密码',
		yinsizhengce:'隐私政策',
		guanyuwomen:'关于我们',
		mimashuoming:'密码必须是8-20位大小写字母和数字组合，不能是纯数字或纯字母',
		qingshurujiumima:'请输入旧密码',
		qingshuruxinmima:'请输入新密码',
		quedingxiugai:'确定修改',
		
		shouye:'首页',
		zhibo:'直播',
		wode:'我的',
		xitongxiaoxi:'系统消息',
		wodedingdan:'我的订单',
		bangzhufankui:'帮助反馈',
		xiugaiziliao:'修改资料',
		xiaofeimingxi:'消费明细',
		zhibojilu:'直播记录',
		tijiao:'提交',
		caozuochenggong:'操作成功',
		tishi:'提示',
		quedingtuichudenglu:'确定退出登录吗？',
		queding:'确定',
		wentibangzhu:'问题帮助',
		woyaofankui:'我要反馈',
		fankuiwenti:'反馈问题',
		qingmiaoshuniyaofankuidewenti:'请描叙你要反馈的问题...',
		sousuo:'搜索',
		sousuoniganxingqudeneirong:'搜索你感兴趣的内容',
		zhibojianbiaoti:'直播间标题',
		zhibojianbeijing:'直播间背景',
		zhibojianbiaoqian:'直播间标签',
		zhibojianhuazhi:'直播间画质',
		geinidezhibojianqugemingziba:'给你的直播间取一个名字吧~',
		qingshurukaibomiyao:'请输入开播秘钥',
		kaishizhibo:'开始直播',
		shengyin:'声音',
		liwutexiao:'礼物特效',
		gengduo:'更多',
		gouwuche:'购物车',
		zaixianguanzhong:'在线观众',
		danmushuoming:'平台严禁未成年人充值打赏，严禁以陪玩等方式诱导打赏私下交易，严禁涉黄涉政、谩骂等内容，请注意财产安全，谨防网络诈骗，理性消费。',
		tianjiaguanliyuan:'添加管理员',
		jinyan:'禁言',
		jiechuejinyan:'解除禁言',
		tichufangjian:'踢出房间',
		shangpinxiangqing:'商品详情',
		lijijiagou:'立即加购',
		xuanzeguige:'选择规格',
		quanbuliwu:'全部礼物',
		ge:'个',
		bi:'币',
		guanliyuan:'管理员',
		kuaijieduanyu:'快捷短语',
		gonggao:'公告',
		xinzengkuaijieduanyu:'新增快捷短语',
		qingshuru:'请输入',
		wangjimima:'忘记密码',
		youxiangzhuce:'邮箱注册',
		huoquyanzhengma:'获取验证码',
		qingshuruningdeyouxiangzhanghao:'输入您的邮箱账号',
		qingshuruyanzhengma:'请输入验证码',
		qingshurumima:'请输入密码',
		mimadenglu:'密码登录',
		woyiyuedubingtongyi:'我已阅读并同意',
		yonghuxieyi:'用户协议',
		yinsixieyi:'隐私协议',
		denglu:'登录',
		chongxindenglu:'重新登陆',
		xiayibu:'下一步',
		haimeizhanghao:'还没有账号',
		quzhuce:'去注册',
		yiyouzhanghao:'已有账号',
		qudenglu:'去登录',
		shezhijibenxinxi:'设置基本信息',
		nichengtishi:'仅支持字母、数字和标点符号，最少6位，不能使用空格',
		shezhiyonghuming:'设置用户名',
		yonghumingtishi:'用户名为6-18位，大小写字母或数字',
		shezhijiaoyimima:'设置交易密码',
		jiaoyimimatishi:'交易密码必须是6位数字组合',
		qingxuanze:'请选择',
		yaoqingma:'邀请码（选填）',
		qingshuruyaoqingma:'输入邀请码',
		shezhixinmima:'设置新密码',
		xuanzeningdeguojia:'选择您的国家',
		zhuce:'注册',
		qingshuruyonghuming:'请输入用户名',
		gaoqinghuazhi:'高清画质',
		putonghuazhi:'普通画质',
		kaishizhibo:'开始直播',
		zengsong:'赠送',
		jinrulezhibojian:'进入直播间',
		shuodianshenmene:'说点什么呢...',
		zanwushuju:'暂无数据',
		songgei:'送给',
		huifang:'回放',
		quedingtuichudengluma:'确定退出登录吗?',
		xunibi:'虚拟币',
		quanbu:'全部',
		appxiazai:'APP下载',
		dingdanjine:'订单金额',
		dingdanbianhao:'订单编号',
		chuangjianshijian:'创建时间',
		zhubozanshilikai:'主播暂时离开',
		mashanghuilai:'马上回来',
		guojianzhuoxiazai:'国际安卓下载',
		anzhuoxiazai:'安卓下载',
		guojipingguoxiazai:'国际苹果下载',
		pingguoxiazai:'苹果下载',
		quanbushangpin:'全部商品',
		yiqiangguang:'已抢光',
		jiagou:'加购',
		shangpinxiangqing:'商品详情',
		lijijiagou:'立即加购',
		yixuan:'已选',
		xuazeguige:'选择规格',
		shangchuanzhong:'上传中',
		shangchuanshibai:'上传失败',
		shifouquedingjieshuzhibo:'是否确定关闭直播？',
		qingyuedubingtongyiyonghuxieyiheyinsixieyi:'请阅读并同意用户协议和隐私协议！',
		quedingqudengluma:'确定去登录吗？'
		
	},
}
 


// WEBPACK FOOTER //
// ./src/i18n/langs/cn.js